import React, { useEffect, useState } from "react";
import ciApi from "services/ciApi";
import {
  getWalletBalancingTableColumns,
  walletBalancingTableLeftFixedColumns,
} from "./walletBalancingTableColumns";
import generateEntityTable from "hocs/generateEntityTable";
import walletBalancingActions from "actions/walletBalancingActions";
import GridContainer from "mui-components/Grid/GridContainer";
import HeaderCard from "mui-components/Cards/HeaderCard";
import ItemGrid from "../../../mui-components/Grid/GridItem";
import SimpleCard from "mui-components/Cards/SimpleCard";
import WalletToggleNav from "components/ui/WalletToggleNav";
import walletPositionActions from "actions/walletPositionActions";
import walletPositionTableColumns, {
  walletPositionTableLeftFixedColumns,
  walletPositionTableSummaries,
} from "../wallet-position/walletPositionTableColumns";

const WalletBalancingsTable = (props) => {
  console.log("WalletBalancingsTable props:", props);

  const [columns, setColumns] = useState([]);
  const [data, setData] = useState({});
  const [selectedComponent, setSelectedComponent] = useState(
    props.tab || "walletBalancings"
  );

  const handleDataFetch = async () => {
    try {
      const response = await ciApi.call({
        httpMethod: "get",
        endpoint: `/clients/${props.id}/wallet_profile`,
      });

      console.log("Wallet profile response:", response);

      if (!response.isSuccess) {
        throw new Error(`Erro ao buscar perfil de carteira: ${response.data}`);
      }

      const data = response.data;
      return data;
    } catch (error) {
      console.error("Erro ao buscar perfil de carteira:", error);
      return [];
    }
  };

  useEffect(() => {
    const fetchColumns = async () => {
      const response = await handleDataFetch();
      setData(response);
      const walletProfile = response.walletProfile;

      const walletProfileColumns =
        getWalletBalancingTableColumns(walletProfile);

      setColumns(walletProfileColumns);
    };

    fetchColumns();
  }, [props.id]);

  const WalletBalancingsComponent = generateEntityTable({
    entityPluralString: "walletBalancings",
    entityActions: walletBalancingActions,
    editorRoutePath: "/client-wallet-balancing-edition",
    columns: columns,
    leftFixedColumns: walletBalancingTableLeftFixedColumns,
    pathId: props.id,
    editOperation: true,
    deleteOperation: false,
  });

  const WalletPositionsComponent = generateEntityTable({
    entityPluralString: "walletPositions",
    entityActions: walletPositionActions,
    columns: walletPositionTableColumns,
    leftFixedColumns: walletPositionTableLeftFixedColumns,
    operations: [],
    summaries: walletPositionTableSummaries,
    pathId: props.id,
    // walletBalancingOperation: true,
    // walletBalancingRoutePath: "/client-wallet-balancing/:id",
  });

  return (
    <>
      <GridContainer>
        <HeaderCard
          cardTitle="Carteira de Investimentos"
          headerColor="orange"
          content={
            <>
              <GridContainer
                spacing={3}
                alignItems="stretch"
                justifyContent="flex-start"
                sx={{ px: { xs: 2, md: 4, lg: 6 } }}
              >
                <ItemGrid key="client.name" xs={12} sm={6} md={4} lg={4}>
                  <SimpleCard
                    title="Cliente"
                    description={data.clientName || "-"}
                    descriptionColor="orange"
                    descriptionStyle="bold"
                  />
                </ItemGrid>

                <ItemGrid key="client.advisorName" xs={12} sm={6} md={4} lg={4}>
                  <SimpleCard
                    title="Assessor responsável"
                    description={data.advisorName || "-"}
                  />
                </ItemGrid>

                <ItemGrid key="client.profile" xs={12} sm={6} md={4} lg={3}>
                  <SimpleCard
                    title="Perfil Confiança"
                    description={data.internInvestmentProfile || "-"}
                  />
                </ItemGrid>
              </GridContainer>
              <GridContainer
                spacing={3}
                alignItems="stretch"
                justifyContent="flex-start"
                sx={{ px: { xs: 2, md: 4, lg: 6 } }}
              >
                <ItemGrid key="client.email" xs={12} sm={6} md={4} lg={4}>
                  <SimpleCard title="E-mail" description={data.email || "-"} />
                </ItemGrid>

                <ItemGrid key="client.name" xs={12} sm={6} md={4} lg={4}>
                  <SimpleCard
                    title="Nº da Conta BTG"
                    description={data.btgCode || "-"}
                  />
                </ItemGrid>

                <ItemGrid key="client.advisorName" xs={12} sm={6} md={4} lg={3}>
                  <SimpleCard
                    title="Nº da Conta XP"
                    description={data.xpCode || "-"}
                  />
                </ItemGrid>
              </GridContainer>
            </>
          }
        />
      </GridContainer>
      <WalletToggleNav
        clientId={props.id}
        location={selectedComponent}
        onClick={setSelectedComponent}
      />
      {selectedComponent === "walletPositions" ? (
        <WalletPositionsComponent />
      ) : (
        <WalletBalancingsComponent />
      )}
    </>
  );
};

export default WalletBalancingsTable;
